import { RowIconWrapper } from './Components.styles';

export const RowIcon = ({ color, size = 40 }) => {
  return (
    <RowIconWrapper $bg={color.bg} $size={size}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size - 20}
        height={size - 20}
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M16.667 10.831c0 4.167-2.916 6.25-6.383 7.458a.833.833 0 01-.558-.008c-3.475-1.2-6.392-3.283-6.392-7.45V4.998a.833.833 0 01.833-.834c1.667 0 3.75-1 5.2-2.266a.975.975 0 011.267 0c1.458 1.275 3.533 2.266 5.2 2.266a.833.833 0 01.833.834v5.833z"
          stroke={color.color}
          strokeWidth={1.66667}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </RowIconWrapper>
  );
};
